module.exports = __webpack_public_path__ + "static/media/svm.927d9a1f.svg";